import { render, staticRenderFns } from "./Impostazioni.vue?vue&type=template&id=3e15fe6d"
import script from "./Impostazioni.vue?vue&type=script&lang=js"
export * from "./Impostazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports